import type { HistoryTone } from '@/Ship/Components/History'

/**
 * Вид події історії справи — за ним стрічка вирішує, що показати в
 * подробицях (`SPEC-011` §6, колонка `payload`).
 */
export type ActivityHistoryKind = 'created' | 'updated' | 'assigned' | 'deadline' | 'overdue' | 'completed' | 'removed'

export interface ActivityHistoryEventInfo {
    label: string
    tone: HistoryTone
    kind: ActivityHistoryKind
}

/**
 * Коди подій історії справи — рівно enum беку
 * `backend/web/src/Containers/ActivityContainer/Database/Enum/ActivityHistoryEvent.php`
 * (`SPEC-011` §6). Підписи й тони збігаються з подіями дзвіночка (§7, ADR 040).
 *
 * Ключі — **буквальні** коди: мапу звіряє з беком вартовий «кожен код події
 * історії з бека має підпис на фронті» (`Ship/Helpers/architectureGuard.test.ts`).
 */
export const ACTIVITY_HISTORY_EVENT_MAP: Record<string, ActivityHistoryEventInfo> = {
    activity_created: { label: 'Справу створено', tone: 'blue', kind: 'created' },
    activity_updated: { label: 'Змінено дані справи', tone: 'neutral', kind: 'updated' },
    activity_assigned: { label: 'Справу призначено', tone: 'blue', kind: 'assigned' },
    activity_deadline_changed: { label: 'Змінено крайній термін', tone: 'orange', kind: 'deadline' },
    activity_overdue: { label: 'Справа прострочена', tone: 'red', kind: 'overdue' },
    activity_completed: { label: 'Справу завершено', tone: 'green', kind: 'completed' },
    activity_removed: { label: 'Справу видалено', tone: 'red', kind: 'removed' },
}
